import { refreshToken } from "./session-tokens";
import {
  acceptInvite,
  acceptInviteSSO,
  runPublicCredentials,
} from "./invitations";
import { getPublicClient } from "./web/public-client";
import { LoginCredentials } from "@/types/Auth";
import { publicApi, protectedApi } from "./method";

export const authApi = {
  login: async (credentials: LoginCredentials) => {
    const response = await publicApi.post<any>("/auth/login", {
      ...credentials,
      email: credentials.email.toLowerCase(),
    });

    return response.data;
  },

  refreshToken,

  logout: async (refresh_token: string): Promise<void> => {
    const response = await protectedApi.post<any>("/auth/logout", {
      refresh_token,
    });
    return response.data;
  },

  requestPasswordReset: async (
    email: string,
    reset_url: string,
  ): Promise<void> => {
    const response = await publicApi.post<any>("/auth/password/request", {
      email: email.toLowerCase(),
      reset_url,
    });
    return response.data;
  },

  setPassword: async (password: string, token: string): Promise<void> => {
    const response = await publicApi.post<any>("/auth/password/reset", {
      password,
      token,
    });
    return response.data;
  },

  acceptInvite,
  acceptInviteSSO,

  checkAccess: async (unique_key: string): Promise<{ user_id: string }[]> => {
    const client = await getPublicClient();
    return Array.from(
      await runPublicCredentials(
        client.invitations.checkCode({ payload: { unique_key } }),
      ),
    );
  },
};
